/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import boardsMenu, { BoardsMenuState } from './boards-menu';
import notificationsPane, {
  NotificationsPaneState,
} from './notifications-pane';
import overlay, { OverlayState } from './overlay';

export interface UiState {
  boardsMenu: BoardsMenuState;
  notificationsPane: NotificationsPaneState;
  overlay: OverlayState;
}

export default combineReducers({
  boardsMenu,
  notificationsPane,
  overlay,
});
